/**
 * Chapter definitions — a single source of truth shared by the cover
 * navigation, the floating menu dialog and the scroll section index.
 */

import heroImage from "@/assets/hero-heavy-lift-v2.jpg";
import shipyardImage from "@/assets/shipyard-vessel-v2.jpg";
import shippingImage from "@/assets/port-ship-agency-showcase.jpg";
import industrialImage from "@/assets/people-leadership.jpg";

export interface Chapter {
  /** Stable key, also used as translation index */
  key: "scope" | "experience" | "shipping" | "contact";
  index: string;
  /** Anchor id on the home page, or null for a real route */
  hash: string | null;
  to?: string;
  image: string;
}

export const COVER_IMAGE = heroImage;

export const CHAPTERS: Chapter[] = [
  { key: "scope", index: "01", hash: "scope", image: shipyardImage },
  { key: "experience", index: "02", hash: "experience", image: industrialImage },
  { key: "shipping", index: "03", hash: "shipping", image: shippingImage },
  { key: "contact", index: "04", hash: null, to: "/contact", image: heroImage },
];
